// utils/reducerHelpers.js

// Update a single conversation by applying changes
export const updateConversation = (conversations, conversationId, changes) => {
    return conversations.map(conversation => {
    if (conversation.id === conversationId) {
      return { ...conversation, ...changes };
    }
    return conversation;
  });
};

// Add or update a message within a conversation
export const addOrUpdateMessage = (conversation, newOrUpdatedMessage) => {
    const messageIndex = conversation.messages.findIndex(msg => msg.id === newOrUpdatedMessage.id);
    if (messageIndex > -1) {
        const newMessages = [...conversation.messages];
        newMessages[messageIndex] = newOrUpdatedMessage;
        return { ...conversation, messages: newMessages };
    } else {
      const newMessages = [...conversation.messages, newOrUpdatedMessage];
      return { ...conversation, messages: newMessages };
    }
};


// Add or update a whole conversation object while preserving existing messages
export const mergeExistingOrNewConversationAndGetUpdatedConversationObject = (existingConversation, newConversation) => {
  
  if (existingConversation) {
    const existingMessages = Array.isArray(existingConversation.messages) 
      ? existingConversation.messages.map(msg => ({...msg})) // Create deep copies
      : [];
      
    const newMessages = Array.isArray(newConversation.messages) 
      ? newConversation.messages.map(msg => ({...msg})) // Create deep copies
      : [];
      
    // Use a Map to ensure unique messages by id
    const messageMap = new Map();
    existingMessages.forEach(msg => messageMap.set(msg.id, msg));
    newMessages.forEach(msg => messageMap.set(msg.id, msg));
    
    const mergedMessages = Array.from(messageMap.values());
    // Sort by delivered_at first if available, otherwise by deliver_after, then created_at
    mergedMessages.sort((a, b) => {
      const aTime = a.delivered_at ? new Date(a.delivered_at).getTime() :
        a.deliver_after ? new Date(a.deliver_after).getTime() :
          new Date(a.created_at).getTime();

      const bTime = b.delivered_at ? new Date(b.delivered_at).getTime() :
        b.deliver_after ? new Date(b.deliver_after).getTime() :
          new Date(b.created_at).getTime();

      return aTime - bTime;
    });

    const updatedConversation = {
      ...newConversation,
      messages: mergedMessages
    };
    // Replace the existing conversation with the updated one
    return updatedConversation;
  } else {
    // Add new conversation if it doesn't exist, making sure to copy messages
    return {
      ...newConversation,
      messages: Array.isArray(newConversation.messages) 
        ? newConversation.messages.map(msg => ({...msg}))
        : []
    };
  }
};

export const removeConversation = (conversations, conversation) => {
  return conversations.filter(conversation => conversation.id !== conversation.id);
};

export const addOrUpdateContact = (contacts, newContact) => {
  const index = contacts.findIndex(contact => contact.id === newContact.id);
  if (index > -1) {
    return [...contacts.slice(0, index), newContact, ...contacts.slice(index + 1)];
  } else {
    return [...contacts, newContact];
  }
};

export const removeContact = (contacts, contact) => {
  return contacts.filter(contact => contact.id !== contact.id);
};

export const addOrUpdateFaq = (faqs, newFaq) => {
  const index = faqs.findIndex(faq => faq.id === newFaq.id);
  if (index > -1) {
    return [...faqs.slice(0, index), newFaq, ...faqs.slice(index + 1)];
  } else {
    return [...faqs, newFaq];
  }
};
